import Button from '@ui/buttons/Button'
import ButtonsFixed, { SpaceButtons } from '@ui/buttons/ButtonsFixed'
import Page from '@shell/Page'
import Header from '@ui/elements/Header'
import { StockUtils } from '@frame/StockUtils'
import { StockFormUtils } from '@screens/frame/stock/StockFormUtils'
import { useOrderState } from '@order/hooks/useOrderState'
import useStartOrderConfig from '@order/hooks/useStartOrderConfig'
import { OrderItem } from '@order/orderTypes'
import FrameTile from '@frame/Frame/FrameTile'
import { FormProvider } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { View } from 'react-native'
import { StockFormSection } from './StockFormSection'
import useStockForm from './useStockForm'
import { useFrameDetails } from '@frame/Frame/useFrameDetails'
import ConfigDebugModal from 'features/debug/ConfigDebugModal'

export default function FrameStock({ item }: { item: OrderItem }) {
  const { t } = useTranslation(['frame', 'ui'])
  const text = 'frame:stock'

  const { form, sources, showTempleStock } = useStockForm(item)

  const { frame, temple } = item

  const { details } = useFrameDetails(frame, { hideQty: true })

  const { goToPrescription } = useStartOrderConfig()

  const setStock = useOrderState((s) => s.setStock)

  const handleSubmit = form.handleSubmit((data) => {
    if (frame && data.frame?.source) {
      setStock(StockUtils.getItemKey(item.id, 'frame'), {
        source: data.frame.source,
        inventory: StockFormUtils.getInventory(data.frame, item),
        trace: data.frame.traceResult || false,
      })
    }
    if (temple && data.temple?.source) {
      setStock(StockUtils.getItemKey(item.id, 'temple'), {
        source: data.temple.source,
        inventory: StockFormUtils.getInventory(data.temple, item),
        trace: data.temple.traceResult || false,
      })
    }
    goToPrescription()
  })

  const hasChanged = form.formState.isDirty

  return (
    <>
      <Page stage="frame">
        <Header
          title={t(`${text}.header.title`)}
          desc={t(`${text}.header.desc`)}
        />
        <FormProvider {...form}>
          {!!frame && (
            <View className="gap-8 px-8 pb-8">
              <FrameTile
                image={frame.url}
                title={frame.default_code}
                type="frame"
                details={details}
              />
              <StockFormSection
                item={frame}
                form={form}
                name="frame"
                sources={sources.frame}
              />
            </View>
          )}
          {!!temple && showTempleStock && (
            <View className="gap-8 px-8 pb-8">
              <FrameTile image={temple.url} title={temple.name} type="temple" />
              <StockFormSection
                item={temple}
                form={form}
                name="temple"
                sources={sources.temple}
              />
            </View>
          )}
        </FormProvider>
        <SpaceButtons />
      </Page>
      <ConfigDebugModal />
      <ButtonsFixed>
        <Button
          label={hasChanged ? t('ui:save') : t('ui:skip')}
          variant={hasChanged ? 'filled' : 'outlined'}
          iconEnd="arrow-narrow-right"
          size="md"
          onPress={handleSubmit}
        />
      </ButtonsFixed>
    </>
  )
}
